<template>
    <page>
        <module enable-flex>
            <view-list ref="view" class="flex-grow" :work-type="workType" :view-config="saasInfo.viewmanage" @load="loadStats">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="姓名">
                            <c-input name="user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="电话">
                            <c-input name="phone"></c-input>
                        </m-search-item>
                        <m-search-item label="所属部门">
                            <c-input name="department_name"></c-input>
                        </m-search-item>
                        <m-search-item label="供应商">
                            <c-select name="supplier_id" async  @search="searchSupplier"></c-select>
                        </m-search-item>
                    </m-search>

                    <!-- 采购账单汇总统计 -->
                    <div class="stats-bar flex">
                        <div class="stats-card card-orange">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">余额总计</span>
                                    <span class="stats-value">￥{{ formatMoney(stats.total_balance) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
                        </div>
                    </div>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_purchase_bill_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!-- 余额 -->
                <template #balance="{data}">
                    <span>￥{{ formatMoney(data.balance) }}</span>
                </template>
                <!-- 可提现余额 -->
                <template #withdrawable_balance="{data}">
                    <span>￥{{ formatMoney(data.withdrawable_balance) }}</span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="80"
                        button-limit="1"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="detail(data)">收支记录</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    components: {},

    data() {
        return {
            workType: 121,
            stats: {}
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo', 'memberTypeDic', 'completedDic'])
    },

    methods: {
        /*******搜索【供应商】下拉框信息*****************/
        searchSupplier(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SUPPLIER',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /**
         * 加载采购账单汇总统计（随列表查询条件联动）
         */
        loadStats(listData, searchParams) {
            this.request({
                url: '/financial/pay/bill/summary',
                data: searchParams || {},
                success: data => {
                    this.stats = data || {};
                }
            });
        },

        /**
         * 金额格式化（分/元统一按数值保留两位小数）
         */
        formatMoney(val) {
            if (val === undefined || val === null || val === '') {
                return '0.00';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0.00' : num.toFixed(2);
        },

        /**
         * 数量格式化
         */
        formatNumber(val) {
            if (val === undefined || val === null || val === '') {
                return '0';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0' : String(Math.round(num));
        },
        /*********打开详情页面**********/
        detail(data) {
            var paramsData = {};
            if (data.bill_user_type == 3){
                paramsData.user_type = 3;
            }else {
                paramsData.user_type = 2;
            }
            paramsData.user_id = data.user_id;
            paramsData.title = data.user_realname +" - 收支记录";
            this.globalDialog('accountRecordList', {
                data: paramsData
            }, () => {
                this.$refs.view.update();
            });
        },
    }
}
</script>

<style lang="stylus" scoped>
    .stats-bar {
        flex-shrink: 0;
        gap: 10px;
        border-top: 1px solid #F5F5F5;
        padding: 8px 12px;

        .stats-card {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex: 1;
            max-width: 360px;
            min-height: 56px;
            padding: 8px 16px;
            border-radius: 6px;
            color: #fff;
            box-sizing: border-box;
            overflow: hidden;

            &.card-blue {
                background: linear-gradient(90deg, #2563eb, #3b82f6);
            }

            &.card-orange {
                background: linear-gradient(90deg, #f97316, #fb923c);
            }

            .stats-info {
                position: relative;
                z-index: 1;

                .stats-title-row {
                    display: flex;
                    align-items: baseline;
                    line-height: 24px;

                    .stats-label {
                        font-size: 12px;
                        opacity: 0.95;
                    }

                    .stats-value {
                        margin-left: 6px;
                        font-size: 18px;
                        font-weight: bold;
                    }
                }

                .stats-summary-row {
                    gap: .5em;
                    margin-top: 2px;
                    font-size: 11px;

                    ins {
                        text-decoration: none;
                        opacity: 0.6;
                    }

                    label {
                        opacity: 0.9;
                    }
                }
            }

            .stats-icon {
                position: absolute;
                right: 14px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 32px;
                line-height: 1;
                opacity: 0.15;

                .tf {
                    font-size: 32px;
                }
            }
        }
    }
</style>
